<template>
  <div v-if="isLoading" class="relative py-5">
    <BaseInnerLoading spinner-class="size-8" />
  </div>
  <ErrorText v-else-if="isError">
    Failed to load terminals
  </ErrorText>
  <ul
    v-else-if="data && data.items.length > 0"
    class="space-y-2"
  >
    <li v-for="terminal in data.items" :key="terminal.id">
      <div
        class="grid grid-cols-6 content-center gap-2 rounded-lg border border-background-fg/8 px-4 py-2 shadow-sm md:grid-cols-12"
      >
        <div
          class="col-span-4 flex items-center font-semibold"
        >
          {{ terminal.serialNumber }}
        </div>

        <div
          class="col-span-2 flex items-center text-xs text-background-fg/70"
        >
          {{ terminal.lastPairedVersion || "-" }}
        </div>

        <div
          class="col-span-3 flex items-center text-xs text-background-fg/70"
        >
          Last transacted
          {{
            terminal.lastTransactedAt
              ? DateFns.formatDistance(
                  terminal.lastTransactedAt,
                  now,
                  {
                    addSuffix: true,
                  }
                )
              : "-"
          }}
        </div>

        <div
          class="col-span-3 flex items-center text-xs text-background-fg/70"
        >
          Last paired
          {{
            terminal.lastPaired
              ? DateFns.formatDistance(
                  terminal.lastPaired,
                  now,
                  {
                    addSuffix: true,
                  }
                )
              : "-"
          }}
        </div>
      </div>
    </li>
  </ul>

  <p v-else class="text-center"
    >No terminals associated with this merchant</p
  >

  <div class="flex justify-end py-2">
    <BasePagination
      v-model="page"
      :page-count="pageCount"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  tenantId: string
}>()

const query = computed(() => ({
  merchantId: props.tenantId,
  ...pagination.value,
}))

const { page, pageCount, pagination } = usePagination({
  count: computed(() => data.value?.count || 0),
  limit: 10,
})

const { data, isLoading, isError } =
  useMerchantDetailTerminals(query)

const now = useNow()
</script>
